import React, { Fragment } from 'react';
import { Modal, Button, Icon, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import { FieldsSelection } from 'components/page/ObjectFilter/components/index';
import styles from '../index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  theme: 'lead',
  onModalOpen: () => {},
  onModalOk: () => {},
  onModalRestore: () => {},
  onModalClose: () => {},
  NeedRestriction: true,
  customPanelBtn: '',
  needRestore: true,
};
const propTypes = {
  theme: PropTypes.string,
  onModalOpen: PropTypes.func,
  onModalOk: PropTypes.func,
  onModalRestore: PropTypes.func,
  onModalClose: PropTypes.func,
  NeedRestriction: PropTypes.bool,
  isDefaultField: PropTypes.bool.isRequired,
  customPanelBtn: PropTypes.string,
  needRestore: PropTypes.bool,
};

class FieldFilterModal extends React.Component {
  state = {
    visiable: false,
  }

  handleEdit = () => {
    const { onModalOpen } = this.props;
    this.setState({ visiable: true });
    onModalOpen();
  };

  hanledModuleOk = () => {
    const { onModalOk } = this.props;
    onModalOk(this.handleCancel);
  }

  handleModuleRestore = () => {
    const { onModalRestore } = this.props;
    onModalRestore(this.handleCancel);
  }

  handleCancel = () => {
    const { onModalClose } = this.props;
    this.setState({ visiable: false });
    onModalClose();
  };

  render() {
    const {
      theme,
      NeedRestriction,
      isDefaultField,
      customPanelBtn,
      needRestore
    } = this.props;
    const { visiable } = this.state;
    const colLayout = {
      xs: 24,
      sm: 11,
    };
    const rowLayout = {
      gutter: 16,
    };

    const footerAction = [
      (
        needRestore &&
        <div className="pull-left">
          <Button onClick={this.handleModuleRestore} className={cx('filter-modal-cusbtn')}>
            <FormattedMessage id="page.FieldFilterModal.ResetDefault" />
          </Button>
          <Tooltip
            placement="top"
            title={<FormattedMessage id="page.FieldFilterModal.ResetDefaultHint" />}
          >
            <Icon type="question-circle-o" className="pl-sm" />
          </Tooltip>
        </div>
      ),
      (
        <Button onClick={this.handleCancel} className={cx('filter-modal-cusbtn')}>
          <FormattedMessage id="global.ui.button.cancel" />
        </Button>
      ),
      (
        <Button key="submit" type="primary" onClick={this.hanledModuleOk} disabled={isDefaultField}>
          <FormattedMessage id="global.ui.button.ok" />
        </Button>
      ),
    ];

    return (
      <Fragment>
        <Button
          className={classNames('btn-ellipse', 'ml-sm', _.isEmpty(customPanelBtn) ? `${theme}-theme-btn` : customPanelBtn)}
          size="small"
          onClick={() => this.handleEdit()}
        >
          <Icon type="edit" />
          {<FormattedMessage id="page.FieldFilterModal.editCol" />}
        </Button>
        <Modal
          title={<FormattedMessage id="page.FieldFilterModal.editCol" />}
          visible={visiable}
          onCancel={() => this.handleCancel()}
          footer={footerAction}
        >
          <FieldsSelection
            needSearchBar
            isFilterModal
            cardCustomClass="modal-select-field"
            theme={theme}
            colLayout={colLayout}
            rowLayout={rowLayout}
            NeedRestriction={NeedRestriction}
          />
        </Modal>
      </Fragment>
    );
  }
}

FieldFilterModal.propTypes = propTypes;
FieldFilterModal.defaultProps = defaultProps;

export default FieldFilterModal;



// WEBPACK FOOTER //
// ./src/components/page/FieldFilterModal/component/FieldFilterModal.jsx